@use '../../scss/utility';
@use './navigation-item.vars';
@use './avatar/avatar';
@use './icon/icon';
@use './label/label';
@use './lead/lead';

:host {
  @include navigation-item.wb-navigation-item-vars;
  display: inline-block;
  -webkit-tap-highlight-color: transparent;
}

.cta {
  display: flex;
  justify-content: center;
  align-items: center;
  height: utility.wb-pixel-to-rem(36px);
  background-color: inherit;
  padding: 0;
  border: none;
  text-decoration: none;
  cursor: pointer;
}

.avatar,
.icon,
.label,
.chevron {
  position: relative;
}

.icon {
  color: var(--navigation-item-icon-leading-color);
}

.lead {
  color: var(--navigation-item-text-lead-color);
  margin-block-end: #{utility.wb-pixel-to-rem(-2px)};
}

.label {
  color: var(--navigation-item-text-main-color);
}

.chevron {
  color: var(--navigation-item-icon-trailing-color);
}

.labels {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding-inline: utility.wb-pixel-to-rem(8px);
}

.notification {
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  height: var(--navigation-item-indicator-size);
  width: var(--navigation-item-indicator-size);
  background-color: var(--navigation-item-indicator-color);
  border-radius: 50%;
}

:host(:hover),
:host(:focus) {
  @include navigation-item.wb-navigation-item-hover-vars;
}

:host(:active) {
  @include navigation-item.wb-navigation-item-active-vars;
}

:host(:focus-visible) {
  @include navigation-item.wb-navigation-item-focus-vars;
  outline: var(--navigation-item-border-ring-weight) solid var(--navigation-item-border-ring-color);
  outline-offset: utility.wb-pixel-to-rem(1px);
}
